<template>
    <div class="md-layout-item md-small-size-100">
        <md-card>
            <md-card-header class="md-card-header-text md-card-header-green">
                <div class="card-text">
                    <h4 class="title">{{ this.presetItem.id ? 'Update' : 'Create' }} Presets </h4>
                </div>
            </md-card-header>
            <md-card-content>
                    <div class="md-layout">
                        <div class="md-layout-item md-size-50 md-small-size-100">
                            <div class="md-layout-item">
                                <md-field :class="[{ 'md-error': errors.has('required') },
                                        { 'md-valid': !errors.has('required') && touched.presetItem.name }]">
                                    <label>Name</label>
                                    <md-input v-model="presetItem.name"
                                              data-vv-name="required"
                                              v-validate="modelValidations.presetItem.name"
                                              type="name"
                                              required></md-input>
                                    <slide-y-down-transition>
                                        <md-icon class="error" v-show="errors.has('required')"
                                        >close</md-icon
                                        >
                                    </slide-y-down-transition>
                                    <slide-y-down-transition>
                                        <md-icon
                                                class="success"
                                                v-show="!errors.has('required') && touched.presetItem.name"
                                        >done</md-icon
                                        >
                                    </slide-y-down-transition>
                                </md-field>
                            </div>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Type</label>
                                    <md-select v-model="presetType.type" >
                                        <md-option
                                                v-for="item in presetType.types"
                                                :key="item"
                                                :label="item"
                                                :value="item"
                                        >
                                            {{ item }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout-item md-size-50 md-small-size-100">
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Preset Category</label>
                                    <md-select v-model="presetItem.preset_list_id" md-dense>
                                        <md-option v-for="presetList in allPresetType"
                                                   :key="presetList.id"
                                                   :value="presetList.id"
                                        >
                                            {{ presetList.name }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                            <md-card-content>
                                <div class="md-layout">
                                    <div class="md-layout-item">
                                        <md-field>
                                            <label>Description</label>
                                            <md-input v-model="presetItem.description" type="text"></md-input>
                                            <span class="md-helper-text"
                                            >Ground coffee brewed through a filter.</span
                                            >
                                        </md-field>
                                    </div>
                                </div>
                            </md-card-content>
                        </div>
                    </div>
                    <md-card-actions md-alignment="left">
                        <md-button class="md-success"
                                   native-type="submit"
                                   @click.native.prevent="validate">
                            {{ this.presetItem.id ? 'Update' : 'Create' }}
                        </md-button>
                    </md-card-actions>
            </md-card-content>
        </md-card>
    </div>
</template>

<script>
import { SlideYDownTransition } from "vue2-transitions";
export default {
    components: {
        SlideYDownTransition
    },
    name: "Presets",
    data() {
        return {
            presetItem: {
                preset_list_id: "",
            },
            presetListItem: {},
            presetListSize: {},
            presetListExtra: {},
            allPresetLists: [],
            allPresetType: [],
            presetType: {
                type: "None",
                types:['item_size']
            },
            modelValidations: {
                presetItem: {
                    name: {
                        required: true,
                    }
                }
            },
            touched: {
                presetItem: { name: false }
            },
        }
    },
    watch: {
        required() {
            this.touched.presetItem.name = true;
        },
        presetType: {
            handler: function(newValue) {
                this.$http.secured.get(`/v1/preset_lists?preset_types=${newValue.type}`)
                    .then(response => {
                        this.allPresetType = response.data.preset_lists;
                    })
                    .catch(error => alert(error))
            },
            deep: true
        },
    },
    methods: {
        validate() {
            this.$validator.validateAll().then(isValid => {
                this.$emit("on-submit", this.presetItem, isValid);
                if (isValid == true) {
                    const newObj = {...this.presetItem};
                    if (newObj.id) {
                        this.$http.secured
                            .put(`/v1/preset_items/${newObj.id}`, newObj)
                            .then(() => {
                                this.$router.push('/preset_items')
                            });
                    } else {
                        this.$http.secured
                            .post(`/v1/preset_items`, newObj)
                            .then(() => {
                                this.$router.push('/preset_items')
                            });
                    }
                }
            })
        },

    },
    created() { },
    mounted() {
        if(this.$route.params.id){
            this.$http.secured
                .get(`/v1/preset_items/${this.$route.params.id}`)
                .then(response => {
                    this.presetItem = response.data;
                });
        }

        this.presetType.type = this.presetType.types[0]

    }
}
</script>

<style scoped>

</style>
